import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import TrackingComponent from './components/trackers/TrackingComponent';

const StudentTracking = () => {
  return renderComponent(<TrackingComponent />);
};

export default StudentTracking;
